export default __webpack_public_path__ + "static/media/GT-America-Mono-Bold.5cb65dbc.woff2";